/* eslint-disable no-await-in-loop */
import { RESET_PRODUCT_BOOSTED_DATA } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';
import * as api from './api';
import { ProductBoost } from './models';

export const productBoostListRequest = async ({
  commit,
  getters: { productBoostList }
}, pointOfSaleGuid) => {
  if (productBoostList.length === 0) {
    const response = await api.productBoostListRequest(pointOfSaleGuid);
    const list = ProductBoost.toInstanceList(response.data);
    commit(MutationTypes.PRODUCT_BOOST_LIST_SUCCESS, list);
  }
};

export const createProductBoostRequest = async ({ commit }, productBoostToCreate) => {
  const response = await api.createProductBoostRequest(productBoostToCreate.serialize());
  const productBoost = ProductBoost.toInstance(response.data);
  commit(MutationTypes.CREATE_PRODUCT_BOOST_SUCCESS, productBoost);
};

export const removeProductBoostRequest = async ({ commit }, productBoostGuid) => {
  await api.removeProductBoostRequest(productBoostGuid);
  commit(MutationTypes.REMOVE_PRODUCT_BOOST_SUCCESS, productBoostGuid);
};

export const resetProductBoostedData = async ({ commit }) => {
  commit(RESET_PRODUCT_BOOSTED_DATA);
};
